"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(require("./fetcher"));
var _swr = _interopRequireDefault(require("swr"));
var usePrismicCategoryBanners = function usePrismicCategoryBanners(language, fetchedPrismicContent) {
  return (0, _swr["default"])([language, "usePrismicCategoryBanners"], _fetcher["default"], {
    initialData: fetchedPrismicContent
  });
};
var _default = usePrismicCategoryBanners;
exports["default"] = _default;